import React from "react"
import styled from "styled-components"

const FooterGroup = styled.div`
  background: #f1f3f5;
  padding: 50px 0;
  display: flex;
  justify-content: center;
`

const Copyright = styled.div`
  color: #486791;
  max-width: 500px;
  padding: 0 20px;
  margin-left: 130px;

  @media (max-width: 800px) {
    margin-left: 0;
  }
`

const Footer = ({ children }) => {
  return (
    <div>
      <FooterGroup>
        <Copyright>{children}</Copyright>
      </FooterGroup>
    </div>
  )
}

export default Footer
